import { c as _c } from "react/compiler-runtime";
import { Badge } from '@onefootprint/ui';
import isUndefined from 'lodash/isUndefined';
import { useTranslation } from 'react-i18next';
import type { FormattedDetails } from '../../../../../../onboarding-business-insight.types';
import LineItem from '../../../line-item';
import useOtherDetailText from './hooks/use-other-detail-text';
type OtherBusinessDetailsProps = {
  data: FormattedDetails;
};
const OtherBusinessDetails = t0 => {
  const $ = _c(50);
  const {
    data: t1
  } = t0;
  const {
    formationDate,
    formationState,
    tin,
    entityType,
    phoneNumbers,
    website
  } = t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      keyPrefix: "onboardings"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t2);
  const detailT = useOtherDetailText();
  let t3;
  if ($[1] !== t) {
    t3 = isVerified => {
      if (isUndefined(isVerified)) {
        return null;
      }
      return <Badge variant={isVerified ? "success" : "error"}>{isVerified ? t(_temp) : t(_temp2)}</Badge>;
    };
    $[1] = t;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const renderBadge = t3;
  let t4;
  if ($[3] !== detailT) {
    t4 = detailT("formationDate");
    $[3] = detailT;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== formationDate || $[6] !== t4) {
    t5 = <LineItem label={t4} value={formationDate} />;
    $[5] = formationDate;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== detailT) {
    t6 = detailT("formationState");
    $[8] = detailT;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== formationState || $[11] !== t6) {
    t7 = <LineItem label={t6} value={formationState} />;
    $[10] = formationState;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== detailT) {
    t8 = detailT("tin");
    $[13] = detailT;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== renderBadge || $[16] !== tin.verified) {
    t9 = renderBadge(tin.verified);
    $[15] = renderBadge;
    $[16] = tin.verified;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t8 || $[19] !== t9 || $[20] !== tin.tin) {
    t10 = <LineItem label={t8} badge={t9} value={tin.tin} />;
    $[18] = t8;
    $[19] = t9;
    $[20] = tin.tin;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== detailT) {
    t11 = detailT("entityType");
    $[22] = detailT;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== entityType || $[25] !== t11) {
    t12 = <LineItem label={t11} value={entityType} />;
    $[24] = entityType;
    $[25] = t11;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== detailT || $[28] !== phoneNumbers || $[29] !== renderBadge) {
    let t14;
    if ($[31] !== detailT || $[32] !== renderBadge) {
      t14 = phoneNumber => <LineItem key={phoneNumber.phone} label={detailT("phoneNumber")} badge={renderBadge(phoneNumber.verified)} value={phoneNumber.phone} />;
      $[31] = detailT;
      $[32] = renderBadge;
      $[33] = t14;
    } else {
      t14 = $[33];
    }
    t13 = phoneNumbers.map(t14);
    $[27] = detailT;
    $[28] = phoneNumbers;
    $[29] = renderBadge;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[34] !== detailT) {
    t14 = detailT("website");
    $[34] = detailT;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  let t15;
  if ($[36] !== renderBadge || $[37] !== website.verified) {
    t15 = renderBadge(website.verified);
    $[36] = renderBadge;
    $[37] = website.verified;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  let t16;
  if ($[39] !== t14 || $[40] !== t15 || $[41] !== website.url) {
    t16 = <LineItem label={t14} badge={t15} value={website.url} />;
    $[39] = t14;
    $[40] = t15;
    $[41] = website.url;
    $[42] = t16;
  } else {
    t16 = $[42];
  }
  let t17;
  if ($[43] !== t10 || $[44] !== t12 || $[45] !== t13 || $[46] !== t16 || $[47] !== t5 || $[48] !== t7) {
    t17 = <div className="flex flex-col gap-3">{t5}{t7}{t10}{t12}{t13}{t16}</div>;
    $[43] = t10;
    $[44] = t12;
    $[45] = t13;
    $[46] = t16;
    $[47] = t5;
    $[48] = t7;
    $[49] = t17;
  } else {
    t17 = $[49];
  }
  return t17;
};
export default OtherBusinessDetails;
function _temp($) {
  return $.businessShared.tags.verified;
}
function _temp2($_0) {
  return $_0.businessShared.tags.notVerified;
}